import Vue from 'vue';
import VueResource from 'vue-resource';

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import VueSessionStorage from 'vue-sessionstorage';

import Vuelidate from 'vuelidate'

import App from '@/components/App.vue';
import router from '@/router';
import store from '@/store';

Vue.use(VueResource);
Vue.use(Vuetify);
Vue.use(VueSessionStorage);
Vue.use(Vuelidate)

Vue.config.productionTip = false;

let app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});
